/* IMPORT */
import { SYMBOL_OBSERVABLE_BOOLEAN } from '../symbols.js';
import { isFunction } from '../utils.js';
/* MAIN */
const isObservableBoolean = (value) => {
    return isFunction(value) && (SYMBOL_OBSERVABLE_BOOLEAN in value);
};
/* EXPORT */
export default isObservableBoolean;
